'use strict';
export const GTM_ID = '';
export const AUTHORIZATION = 'Bearer';
export const ERRORS = 'ERROR';
export const VERSION = 'VERSION';
export const FEETS = [3, 4, 5, 6, 7, 8];
export const INCHS =  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
export const HEIGHT_MEASURES = ['m', 'cm'];
export const WEIGHT_MEASURES = ['kg', 'lb'];
export const ABDOMINAL_PERIMETER_MEASURES = ['cm', 'in'];
export const OAUTH_AZURE_CONFIG = 'AZURE';
export const OAUTH_OKTA_CONFIG = 'OKTA';
